import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newlineToHtmlLinebreak',
  standalone: true,
})
export class NewlineToHtmlLinebreakPipe implements PipeTransform {
  public transform(value?: string | null): string {
    if (!value) {
      return `${value}`;
    }
    try {
      return value.replace(/\n/g, ' <br>');
    } catch (replaceException) {
      return value;
    }
  }
}
